function callApi(apiName: string, callbackName: string, params: any) {
  const JSONStr = JSON.stringify({
    method: apiName,
    params: params,
    callback: callbackName,
  });
  window.wpsQuery({
    request: 'fromJSAsynCall("' + JSONStr + '")',
    persistent: false,
  });
}

/**
 * @description: 获取客户端 src
 * @return {*}
 */
export const getClientSrc = () => {
  return new Promise((resolve) => {
    window.getClientSrc = (data: string) => {
      try {
        const dataObj = JSON.parse(data);
        const { getSrc } = dataObj;
        resolve(getSrc);
      } catch (err) {
        resolve('');
      }
    };
    callApi('getSrc', 'getClientSrc', {});
  });
};
